import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Dashboard from "../Pages/Dashboard";
import Tickets from "../Pages/Tickets";
import Users from "../Pages/Users";
import Login from "../Pages/Login";
import Layout from "../Layout/Content";
import AddUser from "../Pages/AddUser";
import CreateTicket from "../Pages/CreateTicket";
import Profile from "../Pages/Profile";
import ResetPassword from "../ResetPassword";
import DetailTicket from "../Pages/DetailTicket";
import ForgotPassword from "../Pages/ForgotPassword";
import { AuthContext } from "../context/AuthContext";
import ProtectedRoute from "../components/ProtectedRoute";

const AppRoutes = () => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div className="p-10 text-center">Loading...</div>;
  }

  return (
    <Routes>
      {/* PUBLIC */}
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* PROTECTED */}
      <Route
        path="/"
        element={user ? <Layout /> : <Navigate to="/login" replace />}
      >
        {/* ADMIN */}
        <Route
          index
          element={
            <ProtectedRoute roles={[3]}>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* IKT + ADMIN */}
        <Route
          path="tickets"
          element={
            <ProtectedRoute roles={[2, 3]}>
              <Tickets />
            </ProtectedRoute>
          }
        />

        <Route
          path="AddUser"
          element={
            <ProtectedRoute roles={[2, 3]}>
              <AddUser />
            </ProtectedRoute>
          }
        />

        <Route
          path="incidents/:id"
          element={
            <ProtectedRoute roles={[2, 3]}>
              <DetailTicket />
            </ProtectedRoute>
          }
        />

        {/* VSI */}
        <Route path="users" element={<Users />} />
        <Route path="CreateTicket" element={<CreateTicket />} />
        <Route path="profile/:id" element={<Profile />} />
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AppRoutes;
